/**
 * Condiciones del servicio publicadas en la landing
 * (deca-landing/src/pages/condiciones-servicio.astro).
 *
 * Si cambias el texto legal, sube la version AQUI y en la landing (y en el
 * otro front) para que el backend registre que version acepto cada cliente.
 */
export const CONDICIONES_VERSION = '2026-10-28';

const LANDING_URL: string =
  (import.meta.env.VITE_LANDING_URL as string | undefined) ?? 'https://www.decaplus.es';

export const CONDICIONES_URL = `${LANDING_URL.replace(/\/$/, '')}/condiciones-servicio`;
